import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const ClassificationList: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            ClassificationList
        </div>
    )
}

export const ClassificationListSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        ClassificationList
    </div>
}

export default ClassificationList